<template>
  <v-container>
    <v-card :elevation="10">
      <v-card-title>
        <h3>報告書記載項目の入力</h3>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>報告日</h3>
          </v-col>
          <v-col
            cols="3"
            v-bind="diffAttributes(
              previousObject.report_date, form.report_date)">
            <date-picker
              v-model="form.report_date"
              :error-messages="error.report_date" />
            <div
              v-if="hasDiff(previousObject.report_date,
                            form.report_date)"
              class="ml-10">
              {{ previousDate(previousObject.report_date,
                              form.report_date) }}
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>宛先</h3>
          </v-col>
          <v-col cols="6">
            <v-textarea
              v-model="form.report_recipient"
              v-bind="diffAttributes(previousObject.report_recipient, form.report_recipient)"
              outlined
              label="宛先名称"
              :error-messages="error.report_recipient"
              rows="2"
              dense />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>ヘッダ文章</h3>
          </v-col>
          <v-col cols="6">
            <v-textarea
              v-model="form.report_head_text"
              v-bind="diffAttributes(previousObject.report_head_text, form.report_head_text)"
              outlined
              placeholder="〜〜より委託を受けたアスベスト有無に関する事前調査結果は、下記に記載した通りであることを報告いたします。"
              :error-messages="error.report_head_text"
              dense />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>報告者</h3>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.report_company"
              v-bind="diffAttributes(previousObject.report_company, form.report_company)"
              outlined
              label="会社名"
              :error-messages="error.report_company"
              dense />
            <v-text-field
              v-model="form.report_representative"
              v-bind="diffAttributes(previousObject.report_representative,
                                     form.report_representative)"
              outlined
              label="代表者名"
              :error-messages="error.report_representative"
              dense />
            <v-text-field
              v-model="form.report_address"
              v-bind="diffAttributes(previousObject.report_address, form.report_address)"
              outlined
              label="住所"
              :error-messages="error.report_address"
              dense />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>報告書調査期間</h3>
          </v-col>
          <v-col
            cols="3"
            v-bind="diffAttributes(
              previousObject.report_started_at, form.report_started_at)">
            <date-picker
              v-model="form.report_started_at"
              :error-messages="error.report_started_at" />
            <div
              v-if="hasDiff(previousObject.report_started_at,
                            form.report_started_at)"
              class="ml-10">
              {{ previousDate(previousObject.report_started_at,
                              form.report_started_at) }}
            </div>
          </v-col>
          <v-col
            cols="3"
            v-bind="diffAttributes(
              previousObject.report_finished_at, form.report_finished_at)">
            <date-picker
              v-model="form.report_finished_at"
              :error-messages="error.report_finished_at" />
            <div
              v-if="hasDiff(previousObject.report_finished_at,
                            form.report_finished_at)"
              class="ml-10">
              {{ previousDate(previousObject.report_finished_at,
                              form.report_finished_at) }}
            </div>
          </v-col>
        </v-row>
        <!-- 調査員の項目 -->
        <div id="interviewer-user">
          <div
            v-for="(user, index) in form.users"
            id="interviewer-user"
            :key="index">
            <v-divider class="mb-4" />
            <v-row dense>
              <v-col
                cols="3"
                class="text-right pr-4 pt-1">
                <h3>調査員 （{{ index + 1 }}人目）</h3>
              </v-col>
              <v-col cols="3">
                <v-combobox
                  v-model="user.name"
                  v-bind="diffAttributes(previousObject.users
                    && previousObject.users[index]
                    && previousObject.users[index].name, user.name)"
                  outlined
                  item-text="name"
                  item-value="name"
                  :items="users"
                  :return-object="false"
                  label="調査員氏名"
                  :error-messages="error[`users.${index}.name`]"
                  dense
                  @change="onUserNameChanged($event, index)" />
              </v-col>
              <v-col cols="3">
                <!-- eslint-disable max-len -->
                <v-select
                  v-model="user.pivot.role_id"
                  v-bind="diffAttributes(previousObject.users
                                           && previousObject.users[index]
                                           && previousObject.users[index].pivot.role_id, user.pivot.role_id,
                                         'user_role_id')"
                  :filled="!isCheckUserName(user.name)"
                  :disabled="!isCheckUserName(user.name)"
                  outlined
                  :items="userRoles"
                  item-value="value"
                  item-text="name"
                  label="調査員の種類"
                  :error-messages="error[`users.${index}.pivot.role_id`]"
                  dense />
                <!-- eslint-disable max-len -->
              </v-col>
            </v-row>
            <v-row dense>
              <v-col
                cols="3"
                class="text-right pr-4">
                <h3>(NADA登録)<br />石綿調査診断士登録証</h3>
              </v-col>
              <v-col cols="5">
                <v-text-field
                  v-model="user.pivot.main_license_code"
                  v-bind="diffAttributes(previousObject.users
                                           && previousObject.users[index]
                                           && previousObject.users[index].pivot.main_license_code,
                                         user.pivot.main_license_code)"
                  outlined
                  label="NADA登録石綿調査診断士"
                  :error-messages="error[`users.${index}.pivot.main_license_code`]"
                  dense />
              </v-col>
              <!-- eslint-disable max-len -->
              <v-col
                cols="3"
                v-bind="diffAttributes(previousObject.users
                                         && previousObject.users[index]
                                         && previousObject.users[index].pivot.main_license_expiration_date,
                                       user.pivot.main_license_expiration_date, 'main_license_expiration_date')">
                <date-picker
                  v-model="user.pivot.main_license_expiration_date"
                  :error-messages="error[`users.${index}.pivot.main_license_expiration_date`]"
                  label="登録証有効期限" />
                <div
                  v-if="hasDiff(
                    previousObject.users
                      && previousObject.users[index]
                      && previousObject.users[index].pivot.main_license_expiration_date,
                    user.pivot.main_license_expiration_date)"
                  class="ml-10">
                  {{ previousDate(
                    previousObject.users
                      && previousObject.users[index]
                      && previousObject.users[index].pivot.main_license_expiration_date,
                    user.pivot.main_license_expiration_date) }}
                </div>
              </v-col>
              <!-- eslint-enable max-len -->
            </v-row>
            <v-row dense>
              <v-col
                cols="3"
                class="text-right pr-4">
                <h3>その他の修了証</h3>
              </v-col>
              <v-col cols="5">
                <div>
                  <v-select
                    v-model="user.pivot.other_license_type"
                    v-bind="diffAttributes(
                      previousObject.users
                        && previousObject.users[index]
                        && previousObject.users[index].pivot.other_license_type,
                      user.pivot.other_license_type, 'other_license_type')"
                    :filled="!isCheckUserName(user.name)"
                    :disabled="!isCheckUserName(user.name)"
                    outlined
                    :items="licenseTypesWithOutNada"
                    item-value="id"
                    item-text="name"
                    label="その他の修了証"
                    :error-messages="error[`users.${index}.pivot.other_license_type`]"
                    dense
                    @change="onUserlicenseTypeChanged($event, user.id, index)" />
                </div>
                <v-text-field
                  v-model="user.pivot.other_license_code"
                  v-bind="diffAttributes(
                    previousObject.users
                      && previousObject.users[index]
                      && previousObject.users[index].pivot.other_license_code,
                    user.pivot.other_license_code)"
                  :filled="!isCheckUserName(user.name)"
                  :disabled="!isCheckUserName(user.name)"
                  outlined
                  label="修了証番号"
                  :error-messages="error[`users.${index}.pivot.other_license_code`]"
                  dense />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="user.pivot.other_license_expiration_date"
                  v-bind="diffAttributes(
                    previousObject.users
                      && previousObject.users[index]
                      && previousObject.users[index].pivot.other_license_expiration_date,
                    user.pivot.other_license_expiration_date)"
                  :filled="!isCheckUserName(user.name)"
                  :disabled="!isCheckUserName(user.name)"
                  label="修了年月日"
                  outlined
                  :error-messages="error[`users.${index}.pivot.other_license_expiration_date`]"
                  dense />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col
                cols="3"
                class="text-right pr-4">
                <h3>担当情報</h3>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="user.pivot.assigned_place"
                  v-bind="diffAttributes(previousObject.users
                    && previousObject.users[index]
                    && previousObject.users[index].pivot.assigned_place, user.pivot.assigned_place)"
                  outlined
                  label="担当箇所"
                  :error-messages="error[`users.${index}.pivot.assigned_place`]"
                  dense />
              </v-col>
              <v-col
                cols="1"
                class="text-right">
                <h3>連絡先</h3>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-if="user"
                  v-model="user.pivot.mobilephone"
                  v-bind="diffAttributes(previousObject.users
                    && previousObject.users[index]
                    && previousObject.users[index].pivot.mobilephone, user.pivot.mobilephone)"
                  outlined
                  label="携帯電話番号"
                  :error-messages="error[`users.${index}.pivot.mobilephone`]"
                  dense />
              </v-col>
            </v-row>
          </div>
        </div>
        <!-- 調査員の項目 -->
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-1">
            <h3>文書記録</h3>
          </v-col>
          <v-col
            cols="6"
            v-bind="diffAttributes(previousObject.document_types, form.document_types)">
            <v-divider />
            <template v-for="(documentType, index) in documentTypes">
              <v-checkbox
                :key="index"
                v-model="form.document_types"
                class="ma-0 pt-0 pr-5"
                dense
                :label="documentType.text"
                :value="documentType.id" />
            </template>
            <v-alert
              v-if="error.document_types"
              dense
              outlined
              type="error">
              {{ error.document_types[0] }}
            </v-alert>
            <template v-if="hasDiff(previousObject.document_types, form.document_types)">
              変更前:
              <span
                v-for="(type, index) in previousObject.document_types"
                :key="`pst-${index}`">
                {{ documentTypeName(type) }}
              </span>
            </template>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-1">
            <h3>調査対象材料</h3>
          </v-col>
          <v-col
            cols="6"
            v-bind="diffAttributes(previousObject.materials, form.materials)">
            <v-divider />
            <template v-for="(material, index) in materials">
              <div
                :key="index"
                class="d-flex flex-wrap">
                <v-checkbox
                  :key="index"
                  v-model="form.materials"
                  class="ma-0 pt-0 pr-5"
                  dense
                  :error="!!error.materials"
                  :label="material.name"
                  :value="material.id" />
                <v-text-field
                  v-if="material.has_other"
                  :key="`field-${index}`"
                  v-model="form.material_other_text"
                  :disabled="!hasOtherText"
                  dense
                  outlined
                  label="その他"
                  v-bind="diffAttributes(
                    previousObject.material_other_text, form.material_other_text)" />
              </div>
            </template>
            <v-alert
              v-if="error.materials"
              dense
              outlined
              type="error">
              {{ error.materials[0] }}
            </v-alert>
            <template v-if="hasDiff(previousObject.materials, form.materials)">
              変更前:
              <span
                v-for="(material, index) in previousObject.materials"
                :key="`pst-${index}`">
                {{ material.name }}
              </span>
            </template>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-1">
            <h3>調査方法</h3>
          </v-col>
          <v-col
            cols="6"
            v-bind="diffAttributes(previousObject.survey_types, form.survey_types)">
            <v-divider />
            <template v-for="(surveyType, index) in surveyTypes">
              <v-checkbox
                :key="index"
                v-model="form.survey_types"
                class="ma-0 pt-0 pr-5"
                dense
                :error="!!error.survey_types"
                :label="surveyType.text"
                :value="surveyType.id" />
            </template>
            <v-alert
              v-if="error.survey_types"
              dense
              outlined
              type="error">
              {{ error.survey_types[0] }}
            </v-alert>
            <template v-if="hasDiff(previousObject.survey_types, form.survey_types)">
              変更前:
              <span
                v-for="(type, index) in previousObject.survey_types"
                :key="`pst-${index}`">
                {{ surveyTypeName(type) }}
              </span>
            </template>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-1">
            <h3>ヒアリング対象者</h3>
          </v-col>
          <v-col
            cols="6"
            v-bind="diffAttributes(previousObject.hearing_targets, form.hearing_targets)">
            <v-divider />
            <template v-for="(hearingTarget, index) in hearingTargets">
              <div
                :key="index"
                class="d-flex flex-wrap">
                <v-checkbox
                  :key="index"
                  v-model="form.hearing_targets"
                  class="ma-0 pt-0 pr-5"
                  dense
                  :label="hearingTarget.text"
                  :value="hearingTarget.id" />
                <v-text-field
                  v-if="isSelectedHearingTargetOther(hearingTarget.id)"
                  :key="`hearing-targets-${index}`"
                  v-model="form.hearing_target_name"
                  :disabled="!hearingTargetsOtherSelected"
                  dense
                  outlined
                  label="ヒアリング対象者氏名"
                  v-bind="diffAttributes(
                    previousObject.hearing_target_name, form.hearing_target_name)" />
              </div>
            </template>
            <v-alert
              v-if="error.hearing_targets"
              dense
              outlined
              type="error">
              {{ error.hearing_targets[0] }}
            </v-alert>
            <template v-if="hasDiff(previousObject.hearing_targets, form.hearing_targets)">
              変更前:
              <span
                v-for="(type, index) in previousObject.hearing_targets"
                :key="`pst-${index}`">
                {{ hearingTargetName(type) }}
              </span>
            </template>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>建築物所有者</h3>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="form.building_owner"
              v-bind="diffAttributes(previousObject.building_owner, form.building_owner)"
              outlined
              label="建築物所有者"
              :error-messages="error.building_owner"
              dense />
          </v-col>
          <v-col
            cols="2"
            class="text-right pr-4 pt-3">
            <h3>所有者氏名</h3>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="form.building_owner_name"
              v-bind="diffAttributes(previousObject.building_owner_name, form.building_owner_name)"
              outlined
              label="所有者氏名"
              :error-messages="error.building_owner_name"
              dense />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>所有者住所</h3>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.building_owner_address"
              v-bind="diffAttributes(previousObject.building_owner_address,
                                     form.building_owner_address)"
              outlined
              label="所有者住所"
              :error-messages="error.building_owner_address"
              dense />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>連絡先（TEL）</h3>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.building_owner_telephone"
              v-bind="diffAttributes(previousObject.building_owner_telephone,
                                     form.building_owner_telephone)"
              outlined
              label="連絡先（TEL）"
              :error-messages="error.building_owner_telephone"
              dense />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>調査者記入欄</h3>
          </v-col>
          <v-col cols="6">
            <v-checkbox
              v-model="form.is_owner_hearings"
              class="ma-0 pt-0 pr-5"
              dense
              label="所有者へのヒアリングの有無"
              :value="1" />
            <v-textarea
              v-if="form.is_owner_hearings"
              v-model="form.hearing_remarks"
              v-bind="diffAttributes(
                previousObject.hearing_remarks, form.hearing_remarks)"
              :rows="3"
              outlined
              label="備考"
              :error-messages="error.hearing_remarks"
              dense />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>特記事項１</h3>
          </v-col>
          <v-col
            cols="6">
            <v-textarea
              v-model="surveyRemarks"
              v-bind="diffAttributes(previousObject.report_remarks, form.report_remarks)"
              :rows="20"
              outlined
              label="特記事項（整合性確認表で記載した内容）"
              :error-messages="error.report_remarks"
              dense />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>特記事項２</h3>
          </v-col>
          <v-col
            cols="6">
            <v-textarea
              v-model="form.report_remarks"
              v-bind="diffAttributes(previousObject.report_remarks, form.report_remarks)"
              :rows="20"
              outlined
              label="特記事項（報告書で新たに記載する内容）"
              :error-messages="error.report_remarks"
              dense />
          </v-col>
        </v-row>
      </v-card-text>
      <global-footer>
        <template #left>
          <v-btn
            large
            @click.prevent="onReturnClicked">
            <v-icon>mdi-chevron-left</v-icon>
            戻る
          </v-btn>
        </template>
        <template #center>
          <v-btn
            v-if="loginUser.permission > 0"
            large
            color="primary"
            :disabled="form.users.length > 4"
            @click.prevent="onAddInterviewerButtonClicked">
            調査員を追加する
          </v-btn>
          <!-- 調査員削除ボタン -->
          <v-dialog
            v-if="loginUser.permission > 0 && form.users.length > 0"
            v-model="dialog"
            scrollable
            max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-5"
                color="error"
                large
                v-bind="attrs"
                v-on="on"
                @click.prevent="selectedUsers = []">
                調査員を削除する
              </v-btn>
            </template>
            <v-card>
              <v-card-title>部位の選択</v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pb-5">
                <v-alert
                  class="warning"
                  dark
                  dense>
                  選択した調査員を削除します。
                  この操作は元に戻せません。
                </v-alert>
                <v-checkbox
                  v-for="(user, index) in form.users"
                  :key="index"
                  v-model="selectedUsers"
                  :label="user.name ? user.name : '調査員氏名なし'"
                  :value="user"
                  :hide-details="true"
                  multiple
                  dense />
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialog = false">
                  キャンセル
                </v-btn>
                <v-spacer />
                <v-btn
                  color="error"
                  :disabled="selectedUsers.length === 0"
                  @click="onDeleteCardClicked">
                  削除する
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- 調査員削除ボタン -->
        </template>
        <template #right>
          <v-btn
            v-if="!form.readonly"
            large
            color="default"
            class="mr-1"
            :disabled="!hasChanges"
            @click.prevent="onDraftSaveClicked">
            ブラウザに一時保存
          </v-btn>
          <v-btn
            large
            color="primary"
            @click.prevent="onNextClicked">
            次へ
            <v-icon right>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
      </global-footer>
    </v-card>
  </v-container>
</template>

<script>

import {
  getStepSession, markAsUnsavedSession, setStepObjectId, setStepSession,
} from '../../logic/session'
import DatePicker from '../DatePicker'
import PreviousDiff from '../../mixins/PreviousDiff'

import {
  HEARING_TARGET_OTHER,
  HEARING_TARGETS,
} from '../../consts/HearingTarget'

export default {
  name: 'ReportEditStep2',
  components: { DatePicker },
  mixins: [PreviousDiff],
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    materials: {
      type: Array,
      default: () => ([]),
    },
    previousObject: {
      type: Object,
      default: () => ({}),
    },
    licenseTypes: {
      type: Array,
      default: () => ([]),
    },
    users: {
      type: Array,
      default: () => ([]),
    },
    rooms: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      project: {},
      form: {
        report_date: '',
        report_recipient: '',
        report_head_text: '',
        report_started_at: '',
        report_finished_at: '',
        document_types: [],
        materials: [],
        material_other_text: '',
        survey_types: [],
        survey_remarks: '',
        report_remarks: '',
        report_company: '',
        report_representative: '',
        report_address: '',
        hearing_targets: [],
        building_owner: '',
        building_owner_name: '',
        building_owner_address: '',
        building_owner_telephone: '',
        is_owner_hearings: '',
        hearing_remarks: '',
        users: [{
          id: '',
          name: '',
          pivot: {
            role_id: '',
            main_license_code: '',
            main_license_expiration_date: '',
            other_license_type: '',
            other_license_code: '',
            other_license_expiration_date: '',
            assigned_place: '',
            mobilephone: '',
            telephone: '',
            fax: '',
          },
        }],
      },
      documentTypes: [
        { id: 1, text: '設計図書' },
        { id: 2, text: '維持保全記録' },
      ],
      surveyTypes: [
        { id: 1, text: '文書調査' },
        { id: 2, text: '現場調査' },
        { id: 4, text: '分析調査' },
      ],
      hearingTargets: HEARING_TARGETS,
      error: {},
      hasChanges: false,
      dialog: false,
      selectedUsers: [],
      userRoles: [
        { name: '協会審査員', value: 2 },
        { name: '主任調査員', value: 1 },
      ],
      loginUser: this.$store.state.auth,
    }
  },
  computed: {
    surveyRemarks: {
      get() {
        if (this.form.survey_remarks) return this.form.survey_remarks

        const remarksInRooms = this.rooms.filter((room => !!room.remarks))
        return remarksInRooms.length ? remarksInRooms.map((room) => `${room.room_no} ${room.room_name}\n${room.remarks}`).join('\n') : ''
      },
      set(newVal) {
        this.form.survey_remarks = newVal
      },
    },
    isCheckUserName: () => (name) => (!!name),
    hasOtherText() {
      return this.materials.filter(
        material => (this.form.materials.indexOf(
          material.id,
        ) !== -1 && material.has_other),
      ).length > 0
    },
    documentTypeName() {
      return (type) => this.documentTypes.find(item => item.id === type).text
    },
    surveyTypeName() {
      return (type) => this.surveyTypes.find(item => item.id === type).text
    },
    hearingTargetName() {
      return (type) => HEARING_TARGETS.find(item => item.id === type).text
    },
    licenseTypesWithOutNada() {
      return this.licenseTypes.filter(type => type.id !== 1)
    },
    // 他の修了証の名前
    getOtherlicenseTypeName() {
      return (type) => this.licenseTypes.find(item => item.id === type)?.name
    },
    hearingTargetsOtherSelected() {
      return this.form.hearing_targets.find((target) => target === HEARING_TARGET_OTHER)
    },
  },
  watch: {
    surveyRemarks(newVal, oldVal) {
      if (!oldVal) {
        this.form.survey_remarks = newVal
      }
    },
    hasChanges() {
      this.$emit('hasChange', this.hasChanges)
    },
  },
  mounted() {
    this.loadItem()
    if (!this.form.report_created_at) {
      this.fetchItem()
    }
    this.fetchLicenseExpirationDate()
  },
  methods: {
    fetchLicenseExpirationDate() {
      this.form.users.forEach((user, index) => {
        this.$set(this.form.users[index].pivot, 'main_license_expiration_date', user.license1?.expiration_date ?? '')
      })
    },
    onUserNameChanged(name, index) {
      const targetUser = this.users.find((user) => user.name === name)
      const targetObject = {
        id: targetUser.id,
        name: targetUser.name,
        pivot: {
          role_id: '',
          main_license_code: targetUser.license1?.code ?? '',
          main_license_expiration_date: targetUser.license1?.expiration_date ?? '',
          other_license_type: '',
          other_license_code: '',
          other_license_expiration_date: '',
          assigned_place: '',
          mobilephone: targetUser.mobilephone,
          telephone: '',
          fax: '',
        },
      }
      this.form.users.splice(index, 1, targetObject)
    },
    onUserlicenseTypeChanged(licenseType, userId, index) {
      const targetUser = this.users.length
        ? this.users.find((user) => user.id === userId)
        : this.form.users[index]
      switch (licenseType) {
        case 2:
          this.$set(this.form.users[index].pivot, 'other_license_code', targetUser.license2?.code ?? '')
          this.$set(this.form.users[index].pivot, 'other_license_expiration_date', targetUser.license2?.expiration_date ?? '')
          break
        case 3:
          this.$set(this.form.users[index].pivot, 'other_license_code', targetUser.license3?.code ?? '')
          this.$set(this.form.users[index].pivot, 'other_license_expiration_date', targetUser.license3?.expiration_date ?? '')
          break
        case 4:
          this.$set(this.form.users[index].pivot, 'other_license_code', targetUser.license4?.code ?? '')
          this.$set(this.form.users[index].pivot, 'other_license_expiration_date', targetUser.license4?.expiration_date ?? '')
          break
        default:
          this.$set(this.form.users[index].pivot, 'other_license_code', '')
          this.$set(this.form.users[index].pivot, 'other_license_expiration_date', '')
          break
      }
    },
    loadItem() {
      const form = getStepSession('report', 2)
      if (form) {
        this.form = form
        if (!form.materials) {
          this.$set(this.form, 'materials', [])
        }
        // 変更があればフラグをセット
        this.$watch('form', () => {
          this.hasChanges = true
        }, { deep: true })
      }
    },
    async fetchItem() {
      const { data } = await window.axios.get(`/api/reports/${this.id}/representative`)
      this.form.report_representative = this.form.report_representative ?? data.name
      this.form.report_company = this.form.report_company ?? '一般社団法人 日本アスベスト調査診断協会'
    },
    async validateItem() {
      try {
        this.form.is_owner_hearings = this.form.is_owner_hearings ?? 0
        await window.axios.post('/api/reports/step1', this.form)
        this.error = {}
        return true
      } catch (e) {
        if (e.response.status === 422) {
          this.error = e.response.data.errors
        }
      }
      return false
    },
    onReturnClicked() {
      this.$emit('change', 1)
    },
    onAddInterviewerButtonClicked() {
      this.form.users.push({
        id: '',
        name: '',
        pivot: {
          role_id: '',
          main_license_code: '',
          main_license_expiration_date: '',
          other_license_type: '',
          other_license_code: '',
          other_license_expiration_date: '',
          assigned_place: '',
          mobilephone: '',
          telephone: '',
          fax: '',
        },
      })

      this.$nextTick(() => {
        const interviewer = document.querySelector('#interviewer-user:last-child')
        const top = interviewer.getBoundingClientRect().y + window.pageYOffset - 50
        window.scrollTo({
          top,
          left: 0,
          behavior: 'smooth',
        })
      })
    },
    onDeleteCardClicked() {
      this.selectedUsers.forEach((selectUser) => {
        if (selectUser.id) {
          const index = this.form.users.findIndex((user) => user.id === selectUser.id)
          this.form.users.splice(index, 1)
        }
        if (!selectUser.id) {
          this.form.users = this.form.users.filter((user) => user.id)
        }
      })
      this.dialog = false
      this.selectedUsers = []
    },
    async onNextClicked() {
      if (await this.validateItem()) {
        if (this.hasChanges) {
          markAsUnsavedSession('report')
        }
        setStepSession('report', 2, this.form)
        setStepObjectId('report', this.form.id)
        this.$emit('change', 3)
      }
    },
    onDraftSaveClicked() {
      setStepSession('report', 2, this.form)
      markAsUnsavedSession('report')
      this.hasChanges = false
    },
    hasDiff(previous, current) {
      return this.form.report_created_at && !!this.form.report_apply_status
        ? this.$super(PreviousDiff).hasDiff(previous, current)
        : false
    },
    diffAttributes(previous, current, name = null, options = null) {
      const hasDiff = this.hasDiff(previous, current)
      if (name === 'user_role_id') {
        const previousRoleName = this.userRoles.find((role) => role.value === previous)?.name
        return {
          class: { edited: hasDiff },
          hint: hasDiff
            ? `変更前: ${previousRoleName}`
            : '',
          'persistent-hint': true,
        }
      }
      if (name === 'other_license_type') {
        const previousTypeName = this.licenseTypes.find((type) => type.id === previous)?.name ?? ''
        return {
          class: { edited: hasDiff },
          hint: hasDiff
            ? `変更前: ${previousTypeName}`
            : '',
          'persistent-hint': true,
        }
      }
      return {
        class: { edited: hasDiff },
        hint: hasDiff
          ? `変更前: ${options ? options[previous] : (previous || '')}`
          : '',
        'persistent-hint': true,
      }
    },
    isSelectedHearingTargetOther(target) {
      return target === HEARING_TARGET_OTHER
    },
  },
}
</script>
